import React from "react";
import { Box, Typography } from "@mui/material";
import { tokens } from "../../utils/figmaTokens";

const SIDES = { borderLeft: "7px solid transparent", borderRight: "7px solid transparent" };

// The charts' tooltip (Figma; 044 D90, D97): a dark bubble pointing at `x`, `y` (px in a
// `position: relative` parent) from above, or from `below` near the parent's top. `anchor`
// "end" hangs it to the left of the point, for a point near the parent's right edge; "start"
// to the right, for a point near its left edge (044 D105, R57). `rows` ({ key, label, value,
// color }) lists a stacked bar's parts (044 D126).
export const ChartTooltip = ({ x, y, below, anchor = "center", title, value, note, rows }) => {
  const dx = anchor === "end" ? "calc(-100% + 20px)" : anchor === "start" ? "-20px" : "-50%";
  return (
    <Box
      sx={{
        position: "absolute",
        left: x,
        top: y,
        transform: below ? `translate(${dx}, 14px)` : `translate(${dx}, calc(-100% - 14px))`,
        pointerEvents: "none",
        zIndex: 1,
        bgcolor: tokens.surface.inverse,
        color: tokens.text.inverse,
        px: "14px",
        py: "10px",
        borderRadius: "8px",
        display: "flex",
        flexDirection: "column",
        gap: "2px",
        whiteSpace: "nowrap",
      }}
    >
      <Typography variant="labelMedium" sx={{ color: "inherit", fontWeight: 600 }}>
        {title}
      </Typography>
      <Typography variant="bodyMediumStrong" sx={{ color: "inherit" }}>
        {value}
      </Typography>
      {rows &&
        rows.map((r) => (
          <Box key={r.key} sx={{ display: "flex", alignItems: "center", gap: "8px" }}>
            <Box aria-hidden sx={{ width: 8, height: 8, borderRadius: "2px", bgcolor: r.color, flexShrink: 0 }} />
            <Typography variant="bodySmall" sx={{ color: "inherit", flex: 1 }}>
              {r.label}
            </Typography>
            <Typography variant="bodySmallStrong" sx={{ color: "inherit", pl: "12px" }}>
              {r.value}
            </Typography>
          </Box>
        ))}
      {note && (
        <Typography variant="bodySmall" sx={{ color: "inherit", opacity: 0.72 }}>
          {note}
        </Typography>
      )}
      <Box
        sx={{
          position: "absolute",
          ...(anchor === "end"
            ? { right: "13px" }
            : anchor === "start"
              ? { left: "13px" }
              : { left: "50%", transform: "translateX(-50%)" }),
          ...(below
            ? { bottom: "100%", ...SIDES, borderBottom: `7px solid ${tokens.surface.inverse}` }
            : { top: "100%", ...SIDES, borderTop: `7px solid ${tokens.surface.inverse}` }),
        }}
      />
    </Box>
  );
};
